import React, {Component} from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { URL,USER } from "../../constants/constant";
import {_axios} from '../../plugins/axios';
import ToasterComponent from "../common/toaster";
import CallCustomer from "./callCustomer";
import {decrptor, maskingAdhaar, maskPassportVID} from "./regex";
import { Button, Collapse, Modal } from "react-bootstrap";

function DigiMerFormLink({ order }) {
  const isPPMC = order?.tests?.[0]?.testType === "PPMC";
  const requestId = order?.appointmentId;
  const requestKey = `${isPPMC ? "PPMC" : "ineligible"}:${requestId || ""}`;
  const requestKeyRef = React.useRef(null);
  const [requestState, setRequestState] = React.useState({
    key: null,
    link: null,
    isLoading: false,
  });

  const isNewRequest = requestKeyRef.current !== requestKey;
  requestKeyRef.current = requestKey;

  React.useEffect(() => {
    let isMounted = true;

    if (!isPPMC || !requestId) {
      setRequestState({ key: requestKey, link: null, isLoading: false });
      return () => {
        isMounted = false;
      };
    }

    setRequestState({ key: requestKey, link: null, isLoading: true });

    _axios
      .get(`${process.env.REACT_APP_FUSER_URL}api/v1/digiMerFormLink/${requestId}`)
      .then((response) => {
        const link = response?.data?.isSuccess
          ? response?.data?.digiMerFormLink
          : null;

        if (isMounted && typeof link === "string" && link.trim()) {
          try {
            const parsedLink = new window.URL(link.trim());
            if (parsedLink.protocol === "http:" || parsedLink.protocol === "https:") {
              setRequestState({ key: requestKey, link: link.trim(), isLoading: false });
            }
          } catch (error) {
            // Ignore malformed links returned by the API.
          }
        }
      })
      .catch(() => {
        // The details page remains usable when the link request fails.
      })
      .finally(() => {
        if (isMounted) {
          setRequestState((previousState) => previousState.key === requestKey
            ? { ...previousState, isLoading: false }
            : previousState);
        }
      });

    return () => {
      isMounted = false;
    };
  }, [isPPMC, requestId, requestKey]);

  if (!isPPMC || !requestId || isNewRequest || requestState.key !== requestKey
      || (!requestState.isLoading && !requestState.link)) {
    return null;
  }

  return (
    <div className="p-b-10 width-100">
      {requestState.isLoading ? (
        "Loading DigiMER form link..."
      ) : (
        <a href={requestState.link} target="_blank" rel="noopener noreferrer">
          DigiMER form
        </a>
      )}
    </div>
  );
}

class HeaderSample extends Component{
  constructor(props){
    super(props);
    this.state = {
        user : USER.user,
        orderStatus : null,
        headerDetails : this.props.orderHeader,
        titleCall : this.props.titleCall,
        title : this.props.title,
        showPopUp: false,
    }

  }

formatTodayTomorrow(date) {
    let currentDate = new Date();
    let tomorrowsDate = new Date()
    tomorrowsDate.setDate(tomorrowsDate.getDate() + 1);

    if (currentDate.getDate() == date.getDate()) {
        return "Today";
    } else if (tomorrowsDate.getDate() == date.getDate()) {
        return "Tomorrow";
    } else {
      return "";
    }
}

componentDidUpdate(prevProps, prevState) {
    this.setState({headerDetails : this.props.orderHeader})
}

shouldComponentUpdate(nextProps, nextState) {
  if (nextProps !== this.props) {
    return true
  } else return false
}

formatDate(date) {
  const months = ["JAN", "FEB", "MAR","APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
  return  date.getDate() + "-" + months[date.getMonth()] + "-" + date.getFullYear();
}

formatAMPM(date) {
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? 'pm' : 'am';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? '0'+minutes : minutes;
    var strTime = hours + ':' + minutes + ' ' + ampm;
    return strTime;
  }

  
  hideRescheduleModal() {
    console.log("This is Closed");
    this.setState({
      showPopUp : false
    })
  }

  navigateToReschedule(id) {
    console.log()
    let routerLink = '/sample/collected/Reschedule/'+id;
    this.props.history.push(routerLink);
  }


  render(){
    let phelboDetails = JSON.parse(localStorage.getItem("user_details"))
    return(
        <div className="header-sample">
              {
                this.state.titleCall ? 
                <Container>
                <Row>
                    <Col xs={9} md={9} className="margin-auto">
                        <div className="font-size-ml bold">
                          {this.state.title ? this.state.title : ''}
                        </div>
                    </Col>
                    <Col xs={3} md={3}  className="text-align-right m-t-10">
                       {
                         this.props.noCall ? ''
                         :
                         <CallCustomer></CallCustomer>
                       }
                    </Col>
                 </Row> 
                 </Container>
                 : 
                 <Container>
                   <Row>

                   <Col md={6} xs={12}>
                    <div className="font-size-sm bold p-b-10 width-100"><div className={`badge-custom-${this.state.headerDetails.orderStatus.currentStatusId}`}>{this.state.headerDetails.orderStatus.statusMessage}</div> </div>
                  </Col>
                   
                  {(this.state.headerDetails.tests[0].testType != null
                    && this.state.headerDetails.tests[0].testType != undefined
                    && this.state.headerDetails.tests[0].testType != "") && 
                    <Col md={3} xs={6}>
                      <div className="font-size-sm bold p-b-15 width-60"><div className="badge-custom-dark-grey"> {this.state.headerDetails.tests[0].testType}</div> </div> 
                    </Col>}


                  {(this.state.headerDetails.isUpsell) &&
                  <Col md={3} xs={6} className="display-flex justify-content-end">
                    <div className="font-size-sm bold p-b-15 width-60"><div className="badge-custom-green"> Upsell </div> </div> 
                  </Col>}


                </Row>
                  <Row>
                    <Col xs={6} md={6}  className="p-b-10 text-align-left margin-auto">
                        <div className="font-size-sm">
                          <span className="font-size-md p-b-10 width-100">DID</span> : <span className="p-b-15 font-size-md base-color bold">{this.state.headerDetails.dependantId ? this.state.headerDetails.dependantId: "NA" }</span>
                        </div>
                        <div className="font-size-sm">
                          <span className="font-size-md p-b-10 width-100">Order ID</span> : <span className="p-b-15 font-size-md bold">{this.state.headerDetails.prOrderId + " ( Request # " + this.state.headerDetails.appointmentId + " )"}</span>
                        </div>
                     </Col>
                     <Col xs={6} md={6}  className="text-align-right">
                       {
                         this.props.noCall ? ''
                         :
                         <CallCustomer></CallCustomer>
                       }
                        
                     </Col>
                  </Row>
                  {[2,3,33,4].includes(this.state.headerDetails.orderStatus.currentStatusId) &&  
                    <Row>
                     <Col xs={7} md={7} className="text-align-left">
                         <div  className="font-size-sm">
                           SLOT
                         </div>
                         <div  className="p-b-10 font-size-md bold">
                             {this.formatDate(new Date(this.state.headerDetails.orderDateTime))} {this.formatAMPM(new Date(this.state.headerDetails.orderDateTime))} 
                             <br/>
                             <span className="deep-pink-color font-size-ml bold">{this.formatTodayTomorrow(new Date(this.state.headerDetails.orderDateTime))}</span>
                         </div>
                     </Col>
                     <Col xs={5} md={5}  className="text-align-right">
                          <div  className="font-size-md bold">
                          <button type="button" className="btn btn-outline-primary width-100 border-curve-10 mt-2" onClick={() => {this.props.onRescheduleRoute(this.state.headerDetails.orderId, this.state.headerDetails.orderDateTime, this.state.headerDetails.appointmentId, 
                            this.state.headerDetails.patientDetails[0].city, this.state.headerDetails.dependantId, this.state.headerDetails.prOrderId, this.state.headerDetails.patientDetails[0].name)}}>Reschedule</button>  
                         </div>
                     </Col>
                  </Row>}
                  {/* {
                  this.showPopUp()
                  } */}
                  <Row>
                     <Col xs={6} md={6} className="text-align-left">
                         <div  className="font-size-sm">
                           NAME
                         </div>
                         <div  className="p-b-10 font-size-md bold">
                             {
                              (this.state.headerDetails.patientDetails ? this.state.headerDetails.patientDetails[0].name : '')
                              + " (Age: " + ((this.state.headerDetails.patientDetails[0].patientAge != null) ? this.state.headerDetails.patientDetails[0].patientAge : "NA")
                              + " Gender: " + ((this.state.headerDetails.patientDetails[0].patientGender != null) ? this.state.headerDetails.patientDetails[0].patientGender : "NA")
                              + ")" 

                             } 
                         </div>
                     </Col>
                     {(![2,3,33,4].includes(this.state.headerDetails.orderStatus.currentStatusId)) &&
                       <Col xs={6} md={6}  className="text-align-right">
                         <div  className="font-size-md bold">
                              <div  className="deep-pink-color font-size-ml bold">        
                                {this.formatTodayTomorrow(new Date(this.state.headerDetails.orderDateTime))}
                              </div>
                             {this.formatDate(new Date(this.state.headerDetails.orderDateTime))}
                             <br/>
                             {this.formatAMPM(new Date(this.state.headerDetails.orderDateTime))}
                         </div>
                     </Col>}
                  </Row>
                  <DigiMerFormLink order={this.props.orderHeader} />
                  <Row>
                  <Col md={6}  className="text-align-left">
                  {(typeof this.state.headerDetails.patientDetails[0].priority == "string"
                            && this.state.headerDetails.patientDetails[0].priority != "") ? (
                            <div className="font-size-md p-b-10 width-100"> 
                                    <b>Priority : </b>{this.state.headerDetails.patientDetails[0].priority}
                            </div>
                            )
                            : ""}
                </Col>
                </Row>
                
                  <Row>
                  <Col md={10} sm={10} xs={10} className="text-align-left">
                      <div className="font-size-md p-b-10 width-100"> 
                        <b>Aadhaar No:</b> {decrptor(this.state.headerDetails.patientDetails[0].aadharNumber) ? maskingAdhaar(decrptor(this.state.headerDetails.patientDetails[0].aadharNumber)): "NA" }
                      </div>
                  </Col>
                  {decrptor(this.state.headerDetails.patientDetails[0].passPort) && 
                  <Col md={10} sm={10} xs={10} className="text-align-left">
                      <div className="font-size-md p-b-10 width-100"> 
                        <b>Passport No / Voter ID:</b> {decrptor(this.state.headerDetails.patientDetails[0].passPort) ? maskPassportVID(decrptor(this.state.headerDetails.patientDetails[0].passPort)): "NA" }
                      </div>
                  </Col>}
                  <Col md={2} sm={2} xs={2} className="text-align-right position-relative">
                      { [4].includes(this.state.headerDetails.orderStatus.currentStatusId) &&
                      <button type="button" className="btn btn-default btn-sm patientEdit" onClick={()=> this.props.onEditCustomer(this.state.headerDetails)}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-pencil-square" viewBox="0 0 16 16">
                          <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
                          <path fill-rule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"/>
                        </svg>
                      </button>}
                  </Col>
                  </Row>

                <Row>
                  <Col md={6}  className="text-align-left">
                          {(typeof this.state.headerDetails.patientDetails[0].corporateName == "string"
                            && this.state.headerDetails.patientDetails[0].corporateName != "") ? (
                            <div className="font-size-md p-b-10 width-100"> 
                                    <b>Corporate :</b> {this.state.headerDetails.patientDetails[0].corporateName}
                            </div>
                            )
                            : ""}

                  </Col>
                  </Row>
                  <Row>
                  <Col md={6}  className="text-align-left">
                          {(typeof this.state.headerDetails.patientDetails[0].employeeId == "string"
                            && this.state.headerDetails.patientDetails[0].employeeId != "") ? (
                            <div className="font-size-md p-b-10 width-100"> 
                                    <b>Emp/PNO :</b> {this.state.headerDetails.patientDetails[0].employeeId}
                            </div>
                            )
                            : ""}

                  </Col>
                  </Row>

                  {/* <Row>
                  <Col md={6}  className="text-align-left">
                          {(typeof this.state.headerDetails.patientDetails[0].maid == "string"
                            && this.state.headerDetails.patientDetails[0].maid != "") ? (
                            <div className="font-size-md p-b-10 width-100"> 
                                    <b>Member ID :</b> {this.state.headerDetails.patientDetails[0].maid}
                            </div>
                            )
                            : ""}

                  </Col>
                  </Row> */}

                  <Row>
                    <Col md={6}  className="text-align-left">

                    {
                         this.props.noCall ? ''
                         :
                            (typeof this.state.headerDetails.patientDetails[0].phoneNumber == "string"
                              && this.state.headerDetails.patientDetails[0].phoneNumber != "") ? (
                              <div className="font-size-md p-b-10 width-100"> 
                                      <b>Customer Ph # :</b> {this.state.headerDetails.patientDetails[0].phoneNumber}
                              </div>
                              )
                              : ""
                    }
                    

                    </Col>
                  </Row>

              </Container>
              }
        </div>
    )
    }
}
export { DigiMerFormLink };
export default HeaderSample;
